const card = {
  defaultProps: {
    // Set the default value for the 'icon' prop
    // icon: <CircleTwoToneIcon />,
  },
  styleOverrides: {
    root: {
      borderRadius: "10px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
      backgroundColor: "#fff",
      padding: "6px",
    },
  },
};

const cardHeader = {
  defaultProps: {},
  styleOverrides: {
    root: {
      // borderBottom: "1px solid",
      paddingRight: "25px",
      paddingTop: "25px",
    },
  },
};

export { card, cardHeader };
